function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.5,70.452A40.868,40.868,0,1,0,3.723,57.429,40.834,40.834,0,0,0,12.5,70.452ZM41.476,6.483A34.994,34.994,0,1,1,6.482,41.477,34.994,34.994,0,0,1,41.476,6.483Z",
  transform: "translate(-0.43 -0.431)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.046,82.093A41.055,41.055,0,0,1,25.067,3.229,41.055,41.055,0,0,1,57.025,78.865,40.8,40.8,0,0,1,41.046,82.093Zm0-81.952a40.916,40.916,0,0,0-15.924,78.6A40.915,40.915,0,0,0,56.97,3.358,40.652,40.652,0,0,0,41.046.141Zm0,75.97A35.064,35.064,0,0,1,16.252,16.253,35.064,35.064,0,1,1,65.84,65.841,34.835,34.835,0,0,1,41.046,76.111Zm0-69.988a34.924,34.924,0,0,0-24.7,59.62,34.924,34.924,0,1,0,49.391-49.39A34.7,34.7,0,0,0,41.046,6.123Z",
  transform: "translate(0 -0.001)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(19.336 25.182)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M151.537,211.556a2.991,2.991,0,0,0,4.23,0l25.607-25.607a2.991,2.991,0,0,0-4.23-4.23l-23.492,23.492-9.58-9.58a2.991,2.991,0,0,0-4.23,4.23Z",
  transform: "translate(-138.898 -180.773)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M153.23,212.07a3.041,3.041,0,0,1-2.164-.9l-11.695-11.695a3.061,3.061,0,1,1,4.329-4.329l9.53,9.53,23.442-23.443A3.061,3.061,0,1,1,181,185.567l-25.607,25.607A3.04,3.04,0,0,1,153.23,212.07Zm-11.695-17.677a2.921,2.921,0,0,0-2.065,4.987l11.695,11.695a2.921,2.921,0,0,0,4.131,0L180.9,185.468a2.921,2.921,0,0,0-4.131-4.131L153.23,204.879l-9.629-9.629A2.9,2.9,0,0,0,141.536,194.394Z",
  transform: "translate(-138.477 -180.342)"
}));

var SvgCheck = function SvgCheck(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82.092,
    height: 82.092,
    viewBox: "0 0 82.092 82.092",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCheck, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/check.80f10f2f.svg";
export { ForwardRef as ReactComponent };